import { IEsqueceuSuaSenhaUseCase } from "../../../presentation/useCases/update/esqueceu_sua_senha_use_case";
import { IAuthRepository } from "../../repositories/auth_repository";

/**
 * EsqueceuSuaSenhaUseCase
 */

export class EsqueceuSuaSenhaUseCase implements IEsqueceuSuaSenhaUseCase {
  constructor(private readonly repository: IAuthRepository) { }

  async esqueceuSuaSenha(
    email: string,
  ): Promise<void> {
    await this.repository.esqueceuSuaSenha(email);
  }
}
